import { USERSUBSCRIPTION } from './subscription.enum';

export const SubscriptionColors = [
  {
    type: USERSUBSCRIPTION.PLATINUM,
    bgColor: '#DCF1F8',
    progressColor: '#16A1D3',
    diamondColor: '#95D4EA',
  },
  {
    type: USERSUBSCRIPTION.GOLD,
    bgColor: '#FFF3CC',
    progressColor: '#FEc003',
    diamondColor: '#FFE07A',
  },
  {
    type: USERSUBSCRIPTION.SILVER,
    bgColor: '#E6E7EF',
    progressColor: '#898CA4',
    diamondColor: '#B7BAD1',
  },
  {
    type: USERSUBSCRIPTION.BRONZE,
    bgColor: '#F9E1D2',
    progressColor: '#D27438',
    diamondColor: '#F3C3A5',
  },
];
